// extracted by mini-css-extract-plugin
export var downloadApp = "DownloadApp-module--download-app--DLxU3";